import { gql } from '@apollo/client'

export const ADD_MAGAZINE_ISSUE = gql`
    mutation addMagazineIssue($input: addEntityInput!) {
        addEntity(input: $input) {
            success
            entity {
                guid
                ... on MagazineIssue {
                    title
                    url
                }
            }
        }
    }
`
